import React from 'react';
import { ResponsiveImageProps } from '../../types/responsive-image';

declare module 'react' {
  interface ImgHTMLAttributes<T> extends HTMLAttributes<T> {
    fetchPriority?: 'high' | 'low' | 'auto';
  }
}

export default function ResponsiveImage({
  image,
  priority = 'low',
  loading = 'lazy',
  width,
  height,
  className,
}: ResponsiveImageProps) {
  return (
    <img
      src={image?.src}
      alt={image?.altText}
      srcSet={image?.srcSets?.join(',')}
      sizes={image?.sizes}
      loading={loading}
      width={width}
      height={height}
      className={className}
      {...{ fetchPriority: priority }}
    />
  );
}
